import React, { useState } from 'react'
import { Modal, Button, Form } from 'antd'
import { SettingOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import CategoryTitleHelp from './CategoryTitleHelp'
import CategorySettingsForm from './CategorySettingsForm'
import { NodeContentProps, NodesById } from '../types'

interface CategorySettingsProps extends NodeContentProps {
  nodesById: NodesById
}

const CategorySettings = ({ node, rules, context, onUpdateValue, nodesById }: CategorySettingsProps) => {
  const [visible, setVisible] = useState(false)
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const cancel = () => {
    form.resetFields()
    setVisible(false)
  }

  const onOk = async () => {
    try {
      // Validate form fields
      const values = await form.validateFields()

      onUpdateValue(node.id, {
        title: values.title
      })

      form.resetFields()
      setVisible(false)
    } catch (error) {
      console.error('Form validation failed:', error)
      console.error('Tarkista lomakkeen tiedot')
    }
  }

  return (
    <>
      <Button
        onClick={() => setVisible(!visible)}
        icon={<SettingOutlined />}
        data-cy={`category-settings-button-${node.id}`}
      />
      {visible && (
        <Modal
          destroyOnHidden
          open={visible}
          title={t('customReportPage:columnSettings')}
          maskClosable={false}
          okText={t('global:save')}
          cancelText={t('global:cancel')}
          onOk={onOk}
          onCancel={cancel}
          styles={{
            content: {},
            body: {
              height: '70vh',
              overflowX: 'clip',
              overflowY: 'scroll'
            }
          }}
          data-cy={`category-settings-modal-${node.id}`}
        >
          <CategorySettingsForm form={form} node={node} rules={rules} context={context} nodesById={nodesById} />
          <CategoryTitleHelp />
        </Modal>
      )}
    </>
  )
}

export default CategorySettings
